import * as React from "react";

function RightArrow(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3.75 12h16.5M13.5 5.25L20.25 12l-6.75 6.75"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const MemoRightArrow = React.memo(RightArrow);
export default MemoRightArrow;
